import { Tooltip } from "antd";
import React, { createContext, useContext, useState } from "react";
import { useHotkeys } from "react-hotkeys-hook";

const HotkeyContext = createContext({ showKeys: false });

export const HotkeyProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [showKeys, setShowKeys] = useState(false);

  useHotkeys(
    "ctrl+shift",
    // "alt",
    () => {
      setShowKeys((prev) => !prev);

      setTimeout(() => {
        setShowKeys(false);
      }, 2000);
    },
    {
      enableOnFormTags: true,
    }
  );

  return (
    <HotkeyContext.Provider value={{ showKeys }}>
      {children}
    </HotkeyContext.Provider>
  );
};

export const useHotkey = () => useContext(HotkeyContext);
